import { Button, Flow, Icon } from 'bold-ui'
import { useState } from 'react'

import { MapaSidebarPanel } from '../components/MapaSidebarPanel'
import { MAPA_SIDEBAR_NAV_ITEMS, MapaSidebarNavItemEnum, TerritorioCamadaQueryModel } from '../model-territorioMapa'
import { TerritorioMapaCamadasForm } from './components/TerritorioMapaCamadasForm'
import { TerritorioMapaCamadasList } from './components/TerritorioMapaCamadasList'
import { TerritorioMapaCamadasPanelTabEnum } from './model-territorioMapaCamadas'

interface MapaCamadasPanelProps {
  camadas: ReadonlyArray<TerritorioCamadaQueryModel>
  refetch: () => void
}

export function MapaCamadasPanel(props: Readonly<MapaCamadasPanelProps>) {
  const { camadas, refetch } = props

  const [selectedTab, setSelectedTab] = useState<TerritorioMapaCamadasPanelTabEnum>(
    TerritorioMapaCamadasPanelTabEnum.LISTAR
  )

  const isAdicionarTab = selectedTab === TerritorioMapaCamadasPanelTabEnum.ADICIONAR

  const handleClickAdd = () => {
    setSelectedTab(TerritorioMapaCamadasPanelTabEnum.ADICIONAR)
  }

  const title = isAdicionarTab ? 'Desenhar camada' : MAPA_SIDEBAR_NAV_ITEMS[MapaSidebarNavItemEnum.CAMADAS].label

  return (
    <MapaSidebarPanel
      title={title}
      actions={
        !isAdicionarTab && (
          <Button kind='primary' skin='outline' size='small' onClick={handleClickAdd}>
            <Flow direction='horizontal' gap={0.5}>
              <Icon icon='plus' />
              Adicionar
            </Flow>
          </Button>
        )
      }
    >
      {isAdicionarTab ? (
        <TerritorioMapaCamadasForm
          onCancel={() => setSelectedTab(TerritorioMapaCamadasPanelTabEnum.LISTAR)}
          refetch={refetch}
        />
      ) : (
        <TerritorioMapaCamadasList camadas={camadas} refetch={refetch} />
      )}
    </MapaSidebarPanel>
  )
}
